import React from "react";
import "./employee.css";
import EmployeeForm from "./EmployeeForm";
import { Toaster } from "react-hot-toast";
import FormHeader from "../Candidate/FormHeader";
import TopHeaderForm from "../Candidate/TopHeaderForm";
const Employee = () => {
  return (
    <>
      <FormHeader />

      <EmployeeForm />
      <TopHeaderForm />
      <Toaster position="top-right" reverseOrder={false} />
    </>
  );
};

export default Employee;
